import { render, staticRenderFns } from "./ToolbarAgenda.vue?vue&type=template&id=4abea3b8&"
import script from "./ToolbarAgenda.vue?vue&type=script&lang=js&"
export * from "./ToolbarAgenda.vue?vue&type=script&lang=js&"
import style0 from "./ToolbarAgenda.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports